import React, {useState} from "react"

import { Link } from "gatsby"
import styled from "@emotion/styled";
import Helmet from 'react-helmet'
import '../components/styles.css'

// import Layout from "../components/layout"
import SEO from "../components/seo"

import Topnav from "../components/topnav";
import Card from "../components/card";

const Cardwrapper = styled.div`
    margin-top: 72px;
    z-index:1;
`

const IndexPage = () => {
  const [questionType, setQuestionType] = useState ("Big")
  return (
    <div>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Questions App</title>
      <meta content="width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no" name="viewport"></meta>
      <link href="https://fonts.googleapis.com/css?family=Merriweather|Rajdhani:600" rel="stylesheet"></link>
    </Helmet>
    <SEO title="Big Questions" keywords={[`questions`]} />
    
    <Topnav setQuestionType={setQuestionType} questionType={questionType} />
    <Cardwrapper>
      <Card questionType={questionType} />
    </Cardwrapper>
  </div>
  )
}

export default IndexPage
